import { z } from "zod";

const clientActionDataSchema = z.object({
	url: z.string().nullable(),
	token: z.string().nullable(),
	clientActionRequestId: z.number(),
	status: z.string().nullish(),
	notificationId: z.union([z.string(), z.number()]).nullish(),
});

export type ClientActionData = z.infer<typeof clientActionDataSchema>;

export const parseClientActionData = (
	data: unknown,
): ClientActionData | null => {
	const result = clientActionDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
